exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardClass{padding-left:10px;padding-right:10px}@media screen and (max-width: 500px){.dashboardClass{padding-left:0px !important;padding-right:0px !important}}\n", ""]);

